<script>
import { mapState } from 'vuex'
import Request from '@src/mixins/request'

export default {
  metaInfo: {
    title: 'Checkin',
    meta: [{ name: 'description', content: 'Checkin' }],
  },

  mixins: [Request],

  props: {
    dropdown: { type: Object, required: true },
    item: { type: Object, required: true },
  },

  $_veeValidate: { validator: 'new' },

  data() {
    return {
      color: 'gold',
      photoIdModal: false,
      form: {
        segment: null,
        noOfGuest: null,
        methodOfPayment: null,
        exchangeRate: null,
        remark: null,
        title: null,
        firstName: null,
        lastName: null,
        placeOfBirth: null,
        dateOfBirth: null,
        nationality: null,
        address: null,
        city: null,
        country: null,
        email: null,
        phoneNumber: null,
        purposeOfStay: null,
        comingFrom: null,
        leavingTo: null,
        identificationId: null,
        identificationExpired: null,
        roomNumber: null,
      },
    }
  },

  computed: {
    ...mapState('app', {
      propertyId: (state) => state.currentProperty.id,
    }),
  },

  mounted() {
    Object.assign(this.form, {
      segment: this.item.segment,
      noOfGuest: this.item.noOfGuest,
      methodOfPayment: this.item.methodOfPayment,
      exchangeRate: this.item.exchangeRate,
      remark: this.item.remark,
      title: this.item.title,
      firstName: this.item.firstName,
      lastName: this.item.lastName,
      placeOfBirth: this.item.placeOfBirth,
      dateOfBirth: this.item.dateOfBirth,
      nationality: this.item.nationality,
      address: this.item.address,
      city: this.item.city,
      country: this.item.country,
      email: this.item.email,
      phoneNumber: this.item.phoneNumber,
      purposeOfStay: this.item.purposeOfStay,
      comingFrom: this.item.comingFrom,
      leavingTo: this.item.leavingTo,
      identificationId: this.item.identificationId,
      identificationExpired: this.item.identificationExpired,
      roomNumber: this.item.roomNumber,
    })
  },

  methods: {
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processCheckIn()
        }
      })
    },
    processCheckIn() {
      this.updateData({
        url: this.endpoint.checkin.process,
        data: {
          property: this.propertyId,
          id: this.item.id,
          data: this.form,
        },
      }).then(() => {
        this.$router.push({ name: 'checkin' })
      })
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseView title="Check-in" :color="color">
      <VLayout row wrap>
        <VFlex class="mb-4" xs12>
          <div class="title mb-2">General</div>

          <BaseControlInput label="Hotel confirmation ID *">
            <VTextField
              :value="item.hotelConfirmation"
              label="Hotel confirmation ID *"
              :color="color"
              disabled
            />
          </BaseControlInput>
          <!-- Hotel confirmation ID * -->

          <BaseControlInput label="Segment *">
            <VAutocomplete
              v-model="form.segment"
              v-validate="'required'"
              data-vv-name="segment"
              label="Segment *"
              :error-messages="errors.collect('segment')"
              :color="color"
              :items="dropdown.segments"
            />
          </BaseControlInput>
          <!-- Segment * -->

          <BaseControlInput label="No. of guest *">
            <VTextField
              v-model="form.noOfGuest"
              v-validate="'required|numeric|min_value:1'"
              data-vv-name="no of guest"
              label="No. of guest *"
              :error-messages="errors.collect('no of guest')"
              :color="color"
            />
          </BaseControlInput>
          <!-- No. of guest * -->

          <BaseControlInput label="Room number *">
            <VAutocomplete
              v-model="form.roomNumber"
              v-validate="'required'"
              data-vv-name="room number"
              label="Room number *"
              :error-messages="errors.collect('room number')"
              :color="color"
              :items="dropdown.roomNumbers"
            />
          </BaseControlInput>
          <!-- Room number * -->

          <!--
          <BaseControlInput label="Room number">
            <VAutocomplete
              v-model="form.roomNumber"
              data-vv-name="room number"
              label="Room number"
              :error-messages="errors.collect('room number')"
              :items="dropdown.roomNumbers"
              :color="color"
            />
          </BaseControlInput>
          -->
          <!-- Room number -->

          <BaseControlInput label="Method of payment *">
            <VAutocomplete
              v-model="form.methodOfPayment"
              v-validate="'required'"
              data-vv-name="method of payment"
              label="Method of payment *"
              :error-messages="errors.collect('method of payment')"
              :color="color"
              :items="dropdown.methodOfPayments"
            />
          </BaseControlInput>
          <!-- Method of payment * -->

          <BaseControlInput label="Exchange rate *">
            <VTextField
              v-model="form.exchangeRate"
              v-validate="'required|numeric'"
              data-vv-name="exchange rate"
              label="Exchange rate *"
              :error-messages="errors.collect('exchange rate')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Exchange rate * -->

          <BaseControlInput label="Remark">
            <VTextarea
              v-model="form.remark"
              data-vv-name="remark"
              label="Remark"
              :error-messages="errors.collect('remark')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Remark -->
        </VFlex>
        <!-- General -->

        <!-- Guest Info -->
        <VFlex class="mb-4" xs12>
          <div class="title mb-2">Guest Info</div>

          <BaseControlInput label="Title *">
            <VAutocomplete
              v-model="form.title"
              v-validate="'required'"
              data-vv-name="title"
              label="Title *"
              :error-messages="errors.collect('title')"
              :color="color"
              :items="dropdown.titles"
            />
          </BaseControlInput>
          <!-- Title * -->

          <BaseControlInput label="First name *">
            <VTextField
              v-model="form.firstName"
              v-validate="'required'"
              data-vv-name="first name"
              label="First name *"
              :error-messages="errors.collect('first name')"
              :color="color"
            />
          </BaseControlInput>
          <!-- First name * -->

          <BaseControlInput label="Last name *">
            <VTextField
              v-model="form.lastName"
              v-validate="'required'"
              data-vv-name="last name"
              label="Last name *"
              :error-messages="errors.collect('last name')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Last name * -->

          <BaseControlInput label="Place of birth">
            <VTextField
              v-model="form.placeOfBirth"
              data-vv-name="place of birth"
              label="Place of birth"
              :error-messages="errors.collect('place of birth')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Place of birth -->

          <BaseControlInput label="Date of birth">
            <BaseDatePicker
              v-model="form.dateOfBirth"
              data-vv-name="date of birth"
              label="Date of birth"
              :error-messages="errors.collect('date of birth')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Date of birth -->

          <BaseControlInput label="Nationality *">
            <VAutocomplete
              v-model="form.nationality"
              v-validate="'required'"
              data-vv-name="nationality"
              label="Nationality *"
              :error-messages="errors.collect('nationality')"
              :color="color"
              :items="dropdown.countries"
            />
          </BaseControlInput>
          <!-- Nationality * -->

          <BaseControlInput label="Address">
            <VTextarea
              v-model="form.address"
              data-vv-name="address"
              label="Address"
              :error-messages="errors.collect('address')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Address -->

          <BaseControlInput label="City">
            <VTextField
              v-model="form.city"
              data-vv-name="city"
              label="City"
              :error-messages="errors.collect('city')"
              :color="color"
            />
          </BaseControlInput>
          <!-- City -->

          <BaseControlInput label="Country *">
            <VAutocomplete
              v-model="form.country"
              v-validate="'required'"
              data-vv-name="country"
              label="Country *"
              :error-messages="errors.collect('country')"
              :color="color"
              :items="dropdown.countries"
            />
          </BaseControlInput>
          <!-- Country * -->

          <BaseControlInput label="Email">
            <VTextField
              v-model="form.email"
              v-validate="'email'"
              data-vv-name="email"
              label="Email"
              :error-messages="errors.collect('email')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Email -->

          <BaseControlInput label="Mobile number *">
            <VTextField
              v-model="form.phoneNumber"
              v-validate="'required'"
              data-vv-name="mobile number"
              label="Mobile number *"
              :error-messages="errors.collect('mobile number')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Mobile number * -->

          <BaseControlInput label="Purpose of stay">
            <VAutocomplete
              v-model="form.purposeOfStay"
              data-vv-name="purpose of stay"
              label="Purpose of stay"
              :error-messages="errors.collect('purpose of stay')"
              :color="color"
              :items="dropdown.stayPurposes"
            />
          </BaseControlInput>
          <!-- Purpose of stay -->

          <BaseControlInput label="Arrival date / time *">
            <VLayout row>
              <VFlex sm6 pr-2>
                <VTextField
                  :value="item.arrivalDate"
                  label="Arrival date *"
                  :color="color"
                  disabled
                />
                <!-- Arrival date * -->
              </VFlex>

              <VFlex sm6 pl-2>
                <VTextField
                  :value="item.arrivalTime"
                  label="Arrival time *"
                  :color="color"
                  disabled
                />
                <!-- Arrival time * -->
              </VFlex>
            </VLayout>
          </BaseControlInput>

          <BaseControlInput label="Departure date / time *">
            <VLayout row>
              <VFlex sm6 pr-2>
                <VTextField
                  :value="item.departureDate"
                  label="Departure time *"
                  :color="color"
                  disabled
                />
                <!-- Departure date * -->
              </VFlex>

              <VFlex sm6 pl-2>
                <VTextField
                  :value="item.departureTime"
                  label="Departure time *"
                  :color="color"
                  disabled
                />
                <!-- Departure time * -->
              </VFlex>
            </VLayout>
          </BaseControlInput>

          <BaseControlInput label="Coming from">
            <VTextField
              v-model="form.comingFrom"
              data-vv-name="coming from"
              label="Coming from"
              :error-messages="errors.collect('coming from')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Coming from -->

          <BaseControlInput label="Leaving to">
            <VTextField
              v-model="form.leavingTo"
              data-vv-name="leaving to"
              label="Leaving to"
              :error-messages="errors.collect('leaving to')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Leaving to -->

          <BaseControlInput label="Passport/ID No.">
            <VTextField
              v-model="form.identificationId"
              data-vv-name="passport id"
              label="Passport/ID No."
              :error-messages="errors.collect('passport id')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Passport/ID No. -->

          <BaseControlInput label="Passport/ID exp date">
            <BaseDatePicker
              v-model="form.identificationExpired"
              data-vv-name="passport exp date"
              label="Passport/ID exp date"
              :error-messages="errors.collect('passport exp date')"
              :color="color"
            />
          </BaseControlInput>
          <!-- Passport/ID exp date -->

          <BaseControlInput label="Identification ID">
            <VDialog v-model="photoIdModal" scrollable>
              <template v-slot:activator="{ on }">
                <VImg
                  :src="item.identificationPhoto"
                  alt="Identification ID"
                  style="cursor: pointer;"
                  v-on="on"
                ></VImg>
              </template>

              <VCard>
                <VCardText>
                  <VImg
                    :src="item.identificationPhoto"
                    alt="Identification ID"
                  ></VImg>
                </VCardText>
                <VCardActions>
                  <VSpacer></VSpacer>
                  <v-btn
                    :color="color"
                    depressed
                    dark
                    @click="photoIdModal = false"
                    >Close</v-btn
                  >
                </VCardActions>
              </VCard>
            </VDialog>
          </BaseControlInput>
          <!-- Identification ID -->

          <BaseControlInput label="Signature">
            <VCard color="grey lighten-5" max-width="150px">
              <VCardText>
                <VImg :src="item.signature" alt="Guest signature"></VImg>
              </VCardText>
            </VCard>
          </BaseControlInput>
          <!-- Signature -->
        </VFlex>
      </VLayout>

      <template slot="card-actions-right">
        <VBtn depressed :disabled="loading" :to="{ name: 'checkin' }"
          >Cancel</VBtn
        >

        <VBtn :color="color" :loading="loading" type="submit" depressed dark>
          Check-in
        </VBtn>
      </template>
    </BaseView>
  </VForm>
</template>
